import { render, staticRenderFns } from "./full.vue?vue&type=template&id=4a426f08&scoped=true&"
import script from "./full.vue?vue&type=script&lang=js&"
export * from "./full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a426f08",
  null
  
)

export default component.exports